import VideoRender from './VideoRender.vue'

export default VideoRender
